module.exports = __webpack_public_path__ + "img/img_intro_1_deco4.e9919ab0.png";